// find #footer-logo-back-to-top, if exist, click it to go back to the top:
const backToTop = document.querySelector("#footer-logo-back-to-top");
if (backToTop) {
  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

// handle megamenu hover problem:
document.querySelectorAll(".menu-item-has-megamenu").forEach((dropdown) => {
  dropdown.addEventListener("mouseleave", () => {
    const megaMenu = dropdown.querySelector(".sub-menu");
    megaMenu.classList.add("sub-menu--hiding");
  });

  dropdown.addEventListener("mouseenter", () => {
    const megaMenu = dropdown.querySelector(".sub-menu");
    megaMenu.classList.remove("sub-menu--hiding");
  });
});

// check if this is a touch device:
function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

document.addEventListener("DOMContentLoaded", function () {
  if (isTouchDevice()) {
    // document.body.classList.add('touch-device');
  } else {
    document.body.classList.add("no-touch-device");
  }
});
